@if (previewImage) {
  <div class="image-container"><img [src]="this.previewImage"  alt="" /></div>
}
@if (is3D) {
  <div class="visualisation-container" #projectPreviewContainer></div>
}
